var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.67 14H4C2.9 14 2 14.9 2 16V22H8.67V14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 10H10.66C9.56003 10 8.66003 10.9 8.66003 12V22H15.33V12C15.33 10.9 14.44 10 13.33 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 17H15.33V22H22V19C22 17.9 21.1 17 20 17Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.01 4.84999C15.32 4.53999 15.4401 4.16999 15.3401 3.84999C15.2401 3.52999 14.9301 3.3 14.4901 3.23L13.53 3.06999C13.49 3.05999 13.4001 2.99998 13.3801 2.95998L12.85 1.89998C12.45 1.08998 11.5401 1.08998 11.1401 1.89998L10.6101 2.95998C10.5901 2.99998 10.5 3.05999 10.46 3.06999L9.50005 3.23C9.06005 3.3 8.76005 3.52999 8.65005 3.84999C8.55005 4.16999 8.67005 4.53999 8.98005 4.84999L9.72005 5.59999C9.75005 5.62999 9.79005 5.75 9.78005 5.79L9.57005 6.70998C9.41005 7.38998 9.67005 7.69997 9.84005 7.82997C10.0101 7.94997 10.3801 8.10999 10.9901 7.74999L11.8901 7.21999C11.9301 7.18999 12.06 7.18999 12.1 7.21999L13.0001 7.74999C13.2801 7.91999 13.51 7.96999 13.69 7.96999C13.9 7.96999 14.0501 7.88997 14.1401 7.82997C14.3101 7.70997 14.5701 7.39998 14.4101 6.70998L14.2001 5.79C14.1901 5.74 14.22 5.62999 14.26 5.59999L15.01 4.84999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking2);
export default __webpack_public_path__ + "static/media/ranking-2.2a58d05af76ae56370da25655ff6c351.svg";
export { ForwardRef as ReactComponent };